import {
  Avatar,
  Button,
  Col,
  ColorPicker,
  List,
  Modal,
  Popover,
  Row,
} from "antd";
import PriceInfo from "./PriceInfo";
import "./PriceTut.css";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  HeartOutlined,
} from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import { SignedInDoctor } from "../auth/interfaces";
import { SignedInContext } from "../AppEnv";
import { startPaymentProcess, SubscriptionPaymentUrl } from "./utils";
import { useNavigate } from "react-router-dom";

const professional = [
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Infiniti Pazienti",
    description: "Sarà possibile creare pazienti senza alcun limite.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Infiniti Dottori",
    description: "Sarà possibile creare dottori senza alcun limite.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "1024Mb Storage",
    description: "A disposizione 1024Mb di Archiviazione Foto.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Tutti gli Esami Posturali",
    description: "Sarà possibile utilizzare tutti degli esami posturali.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Tutti gli Esami Neurologici",
    description: "Sarà possibile utilizzare tutti gli esami neurologici.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Supporto dell' AI senza limite",
    description: "Sarà possibile creare report e analizzare foto con AI.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Logo Personalizzato",
    description:
      "Sarà possibile personalizzare tutti i referti con il proprio logo.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Creazione PDF",
    description: "Sarà possibile creare report in formato PDF.",
  },
  {
    icon: <ExclamationCircleOutlined className="yellow-icon" rev={undefined} />,
    title: "Assistenza",
    description: "Assistenza Professional, accesso all'assistenza rapida.",
  },
  {
    icon: <ExclamationCircleOutlined className="yellow-icon" rev={undefined} />,
    title: "Backup",
    description: "Sarà possibile richiedere un backup da scaricare.",
  },
];

declare global {
  interface Window {
    paypal: any;
  }
}

const PriceProfessional: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();

  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;

  const buySubscription = async () => {
    const paymentStartResp: SubscriptionPaymentUrl = await startPaymentProcess(
      signedInDoctor,
      1
    );
    console.log(paymentStartResp);

    if (paymentStartResp.error) {
      setError(paymentStartResp.error);
    } else window.location.href = paymentStartResp.url;
  };

  /*
  //Old payment method
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (isModalVisible) {
      const script = document.createElement("script");
      script.src =
        "https://www.paypal.com/sdk/js?client-id=AftFaqh1lTBMnK79zaNt8lYwfLyhh8MJkRtZFThAdFnqpKbhc4h7oEUZxnoe-DsIXGGQ9ta0j41Zt0OS&vault=true&intent=subscription";
      script.async = true;
      script.onload = () => {
        if (window.paypal) {
          window.paypal
            .Buttons({
              style: {
                shape: "pill",
                color: "blue",
                layout: "vertical",
                label: "subscribe",
              },
              createSubscription: function (data: any, actions: any) {
                return actions.subscription.create({
                  plan_id: "P-34H098717F2811729M2YQG7Q", // Assicurati di usare il tuo plan_id
                });
              },
              onApprove: function (data: any, actions: any) {
                alert(data.subscriptionID); // Puoi aggiungere un messaggio di successo opzionale per l'abbonato qui
              },
            })
            .render("#paypal-button-container");
        }
      };
      document.body.appendChild(script);
    }
  }, [isModalVisible]);
  */
  return (
    <>
      <div className="cardos">
        <h2 className="lol12">Professional</h2>
        <div className="cardosy">
          <Row className="downly">
            <h2 className="lol1">589</h2>
            <h2 className="lol3">,99</h2>
            <h2 className="lol2">/</h2>
            <h2 className="lol3">Anno</h2>
          </Row>
          <div className="spacedde"></div>

          <List
            itemLayout="horizontal"
            dataSource={professional}
            renderItem={(item, index) => (
              <List.Item>
                <List.Item.Meta
                  avatar={item.icon}
                  title={
                    <Popover title={item.description}>{item.title}</Popover>
                  }
                />
              </List.Item>
            )}
          />
          <div className="buybt">
            <Row></Row>
            <Button className="buybtn" onClick={buySubscription}>
              Abbonati
            </Button>
            {error && <div className="error-message">{error}</div>}
          </div>
        </div>
      </div>

      {/* <Modal
        title="Abbonati a Licenza Professional"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ margin: "75px" }} id="paypal-button-container"></div>
      </Modal>
      */}
    </>
  );
};

export default PriceProfessional;
